import styles from './InvoiceUi.module.css';
import { t } from 'i18next';
import moment from 'moment';
import logoImage from '../../../../assets/images/logo.png';
import { useEffect, useState } from 'react';
import { getSubcriptionDetail } from '../../../../services/paymentService';
import { useSelector } from 'react-redux';

export const InvoiceFullView = ({ invoice, onClose }) => {
    const [subscriptionDetail, setSubscriptionDetail] = useState([]);
    const user = useSelector(state => state.user.user);
    
    // Handle both database invoice and Stripe invoice formats
    const isStripeInvoice = !invoice.invoiceNumber && invoice.number;
    
    // Extract address information
    const billingAddress = isStripeInvoice 
        ? invoice?.customer_address || {}
        : invoice?.billingAddress || {};
    
    const { country, city, line1 } = billingAddress;
    
    useEffect(() => {
        if (isStripeInvoice && invoice?.subscription) {
            getSubscriptionDetails();
        }
    }, []);
    
    const getSubscriptionDetails = async () => {
        if (invoice?.subscription) {
            try {
                let response = await getSubcriptionDetail(invoice.subscription);
                if (response?.status == 200) {
                    setSubscriptionDetail(response?.data);
                }
            } catch (error) {
                console.error('Error fetching subscription details:', error);
            }
        }
    };
    
    // Format date based on invoice source
    const formatDate = (date) => {
        if (!date) return '';
        
        if (isStripeInvoice) {
            return moment.unix(date).format('DD MMM YYYY');
        }
        
        return moment(date).format('DD MMM YYYY');
    };
    
    // Get invoice number
    const invoiceNumber = isStripeInvoice ? invoice.number : invoice.invoiceNumber;
    
    // Get invoice status
    const isPaid = isStripeInvoice ? invoice.paid : invoice.status === 'paid';
    
    // Get invoice amount
    const amount = isStripeInvoice 
        ? (invoice.total / 100)
        : invoice.amount;
    
    // Get invoice currency
    const currency = (isStripeInvoice ? invoice.currency : invoice.currency || 'usd').toUpperCase();
    
    // Get invoice date
    const invoiceDate = isStripeInvoice 
        ? formatDate(invoice.created)
        : formatDate(invoice.createdAt);
    
    // Get plan name and description
    const planName = isStripeInvoice
        ? (subscriptionDetail?.plan?.nickname || t('Profile verification subscription'))
        : invoice.planName;
        
    const planDescription = isStripeInvoice
        ? (subscriptionDetail?.plan?.description || t('Profile verification subscription'))
        : invoice.planDescription;
    
    // Get rate
    const rate = isStripeInvoice
        ? (subscriptionDetail?.plan?.amount / 100) + currency
        : amount + currency;
    
    // Get quantity
    const quantity = isStripeInvoice
        ? (subscriptionDetail.quantity || 1)
        : (invoice.quantity || 1);
    
    return (
        <div className={styles.fullViewContainer} onClick={onClose}>
            <div className={styles.fullViewContent} onClick={(e) => e.stopPropagation()}>
                {/* Invoice Header */}
                <div className={styles.invoiceHeader}>
                    <div className={styles.paidStamp}>{isPaid ? t('status.paid') : t('status.unpaid')}</div>
                    <a href="https://findcv.com" style={{ margin: "0px auto", }}>
                        <img src={logoImage} className={styles.invoiceLogo} alt="FindCV logo" />
                    </a>
                    <div className={styles.invoiceStamp}>{t('INVOICE')}</div>
                </div>

                {/* Invoice Body */}
                <div className={styles.invoiceBody}>
                    <p className={styles.invoiceDetail}>{t('No')} : {invoiceNumber}</p>
                    <p className={styles.invoiceDetail}>{t('Invoice To')} : {isStripeInvoice ? invoice.customer_email : invoice.userEmail}</p>
                    <div className={styles.rowContainer}>
                        <p className={styles.invoiceDetail}>{t('Address')} : {`${country ? country : ''}  ${city ? "," + city : ''} ${line1 ? "," + line1 : ''}`}</p>
                        <p className={styles.invoiceDetail}>{invoiceDate}</p>
                    </div>
                    <div className={styles.filledRow}>
                        <p className={`${styles.dataHeading} ${styles.flex5}`}>{t('Description')}</p>
                        <div className={styles.flex5}>
                            <p className={`${styles.dataHeading} ${styles.center} ${styles.flex1}`}>{t('Rate')}</p>
                            <p className={`${styles.dataHeading} ${styles.center} ${styles.flex1}`}>{t('Qty')}</p>
                            <p className={`${styles.dataHeading} ${styles.center} ${styles.flex1}`}>{t('Amount')}</p>
                        </div>
                    </div>
                    <div className={styles.rowContainer}>
                        <p className={`${styles.invoiceDetail} ${styles.flex5}`}>{planName}</p>
                        <div className={`${styles.flex5}`}>
                            <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{rate}</p>
                            <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{quantity}</p>
                            <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{amount + currency}</p>
                        </div>
                    </div>
                    <div className={styles.dottedRow}>
                        <p className={`${styles.dataHeading} ${styles.flex5} ${styles.weightNormal}`}>{' '}</p>
                        <div className={styles.flex5}>
                            <p className={`${styles.dataHeading} ${styles.center} ${styles.flex1} ${styles.weightNormal}`}>{rate}</p>
                            <p className={`${styles.dataHeading} ${styles.center} ${styles.flex1} ${styles.weightNormal}`}>{quantity}</p>
                            <p className={`${styles.dataHeading} ${styles.center} ${styles.flex1} ${styles.weightNormal}`}>{amount + currency}</p>
                        </div>
                    </div>
                    <div className={styles.rowContainer}>
                        <p className={`${styles.invoiceDetail} ${styles.flex5}`}>{' '}</p>
                        <div className={`${styles.flex5}`}>
                            <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{''}</p>
                            <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{t('Total')}</p>
                            <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{amount + currency}</p>
                        </div>
                    </div>
                    <div className={styles.balanceRow}>
                        <p className={`${styles.balanceData} ${styles.flex5} ${styles.weightNormal}`}>{' '}</p>
                        <div className={styles.flex5}>
                            <p className={`${styles.balanceData} ${styles.center} ${styles.flex1} ${styles.weightNormal}`}>{''}</p>
                            <p className={`${styles.balanceData} ${styles.center} ${styles.flex1} ${styles.weightNormal}`}>{t('Balance Due')}</p>
                            <p className={`${styles.balanceData} ${styles.center} ${styles.flex1} ${styles.weightNormal}`}>{amount + currency}</p>
                        </div>
                    </div>
                    <p className={`${styles.dataHeading}`} style={{ backgroundColor: "transparent", padding: '0px' }}>{t('Transaction')}</p>
                    <div className={styles.dottedRow}>
                        <p className={`${styles.dataHeading} ${styles.flex1} ${styles.justifyCenter}`}>{t('Card')}</p>
                        <p className={`${styles.dataHeading} ${styles.flex1} ${styles.justifyCenter} ${styles.weightNormal}`}>{t('Transaction ID')}</p>
                        <p className={`${styles.dataHeading} ${styles.flex1} ${styles.justifyCenter} ${styles.weightNormal}`}>{''}</p>
                        <p className={`${styles.dataHeading} ${styles.flex1} ${styles.justifyCenter} ${styles.weightNormal}`}>
                            {isStripeInvoice && invoice.status_transitions?.paid_at 
                                ? formatDate(invoice.status_transitions.paid_at) 
                                : invoice.paidAt ? formatDate(invoice.paidAt) : ''}
                        </p>
                    </div>

                    <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{t('Thanks for the payment')}</p>
                    <div className={styles.footerContainer}>
                        <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{t('Find CV Address')}</p>
                        <p className={`${styles.invoiceDetail} ${styles.center} ${styles.flex1}`}>{t('Website')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};
